import React, { useEffect, useState } from "react";
import { getConsent, setConsentGranted, setConsentDenied } from "../lib/analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    setConsentGranted();
    setVisible(false);
  };

  const refuse = () => {
    setConsentDenied();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Bandeau de consentement aux cookies"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] bg-[var(--yono-soft-black)] text-[var(--yono-off-white)]"
    >
      <div className="container-yono py-5 lg:py-6 flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-between">
        <div className="text-[13px] leading-[1.6] max-w-3xl">
          Ce site utilise des cookies de mesure d'audience (Google Analytics)
          pour comprendre l'usage du site et améliorer son contenu. Vos données
          sont anonymisées. Vous pouvez accepter ou refuser librement.
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={refuse}
            className="px-4 py-2 text-[11px] tracking-[0.15em] uppercase border border-white/40 hover:bg-white hover:text-[var(--yono-soft-black)] transition-colors"
            data-testid="cookie-refuse"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 text-[11px] tracking-[0.15em] uppercase bg-[var(--yono-off-white)] text-[var(--yono-soft-black)] hover:opacity-90 transition-opacity"
            data-testid="cookie-accept"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
